function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 16a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V17a1 1 0 0 0-1-1H6zm9 6.732A2 2 0 0 1 16 19a2 2 0 0 1 1 3.732V26a1 1 0 1 1-2 0v-3.268zM8 14V7a7 7 0 0 1 7-7h2a7 7 0 0 1 7 7v7h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V17a3 3 0 0 1 3-3h2zm2 0h12V7a5 5 0 0 0-5-5h-2a5 5 0 0 0-5 5v7zM5 26h6v2H5v-2zm16 0h6v2h-6v-2z"
});

var SvgSecure = function SvgSecure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "c104a671d9315e27afcd547369d5f78e.svg";
export { SvgSecure as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/secure.svg
// module id = null
// module chunks = 